import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[rqaUppercaseInput]',
  standalone: true
})
export class UppercaseInputDirective {
  constructor(private el: ElementRef<HTMLInputElement | HTMLTextAreaElement>) {}

  @HostListener('input', ['$event'])
  onInput(): void {
    const input = this.el.nativeElement;
    const value = input.value;
    const upperValue = value.toUpperCase();

    if (value !== upperValue) {
      const start = input.selectionStart ?? 0;
      const end = input.selectionEnd ?? 0;
      const scrollTop = input.scrollTop;
      input.value = upperValue;

      const nativeInputEvt = new InputEvent('input', { bubbles: true });
      input.dispatchEvent(nativeInputEvt);
      input.setSelectionRange(start, end);
      input.scrollTop = scrollTop;
    }
  }
}
